import {Component, OnInit} from '@angular/core';
import { AuthService } from '@services/auth.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AlertService} from '@services/alert.service';
import {ActivatedRoute} from '@angular/router';
import {StoreService} from '@services/store.service';
import {CategoryService} from '@services/category.service';
import {BaseComponent} from '@components/base/base.component';
import {takeUntil} from 'rxjs/operators';
import {FilesService} from '@services/file.service';


@Component({
  selector: 'app-folder-table',
  templateUrl: './folder-table.component.html',
  styleUrls: ['./folder-table.component.scss']
})
export class FolderTableComponent  extends BaseComponent implements OnInit {

  constructor(
      private modalServ: NgbModal,
      private alertServ: AlertService,
      private route: ActivatedRoute,
      private storeService: StoreService,
      private filesServ: FilesService,
      private authServ: AuthService
  ) {
    super();

  }

  folders = [
    { id: '_admin_', name: 'תיקיה 1' },
    { id: '2', name: 'תיקיה 2' },
    { id: '3', name: 'תיקיה 3' },
    { id: '4', name: 'תיקיה 4' },
    { id: '5', name: 'תיקיה 5' },
    { id: '6', name: 'תיקיה 6' }
  ];

  selectedFolder: any = null;

  files: { folderId: string, name: string, image: string }[] = [
    // { folderId: 1, name: 'קובץ A', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/000b64ebad3c9867bb50185c311350ab5fb580cea482dcc88d19b22ce3c69dc2.jpg' },
    // { folderId: 1, name: 'קובץ B', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/000b64ebad3c9867bb50185c311350ab5fb580cea482dcc88d19b22ce3c69dc2.jpg' },
    // { folderId: 1, name: 'קובץ B', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/000b64ebad3c9867bb50185c311350ab5fb580cea482dcc88d19b22ce3c69dc2.jpg' },
    // { folderId: 1, name: 'קובץ B', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/000b64ebad3c9867bb50185c311350ab5fb580cea482dcc88d19b22ce3c69dc2.jpg' },
    // { folderId: 1, name: 'קובץ B', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/000b64ebad3c9867bb50185c311350ab5fb580cea482dcc88d19b22ce3c69dc2.jpg' },
    // { folderId: 1, name: 'קובץ B', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/000b64ebad3c9867bb50185c311350ab5fb580cea482dcc88d19b22ce3c69dc2.jpg' },
    // { folderId: 1, name: 'קובץ B', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/000b64ebad3c9867bb50185c311350ab5fb580cea482dcc88d19b22ce3c69dc2.jpg' },
    // { folderId: 1, name: 'קובץ B', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/000b64ebad3c9867bb50185c311350ab5fb580cea482dcc88d19b22ce3c69dc2.jpg' },
    // { folderId: 1, name: 'קובץ B', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/000b64ebad3c9867bb50185c311350ab5fb580cea482dcc88d19b22ce3c69dc2.jpg' },
    // { folderId: 1, name: 'קובץ B', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/000b64ebad3c9867bb50185c311350ab5fb580cea482dcc88d19b22ce3c69dc2.jpg' },
    // { folderId: 1, name: 'קובץ B', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/000b64ebad3c9867bb50185c311350ab5fb580cea482dcc88d19b22ce3c69dc2.jpg' },
    // { folderId: 1, name: 'קובץ B', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/000b64ebad3c9867bb50185c311350ab5fb580cea482dcc88d19b22ce3c69dc2.jpg' },
    // { folderId: 1, name: 'קובץ B', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/000b64ebad3c9867bb50185c311350ab5fb580cea482dcc88d19b22ce3c69dc2.jpg' },
    // { folderId: 2, name: 'קובץ C', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/TestFolder/73e46a6d0e22af0866a7731d9f89bb57f5d0342716db21eb7c7d73512721432f.jpg' },
    // { folderId: 2, name: 'קובץ D', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/TestFolder/73e46a6d0e22af0866a7731d9f89bb57f5d0342716db21eb7c7d73512721432f.jpg' },
    // { folderId: 3, name: 'קובץ E', image: 'https://s3.eu-central-1.amazonaws.com/il.co.meat2me.api/000b64ebad3c9867bb50185c311350ab5fb580cea482dcc88d19b22ce3c69dc2.jpg' },
  ];
  isAdmin = this.authServ.isAdmin();
  selectedItem: any;
  storeId;




  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.destroyed$)).subscribe((params) => {
      const location = params.get('location');
      if (location == 'shop-page') {
        // console.log(location);
        this.storeService.getSidebarChange(true);
        this.isAdmin = false;
        this.storeId = localStorage.getItem('STORE_ID').toString();
      }
    });
      this.filesServ
          .getFiles()
          .subscribe((res:any) => {
            this.files = res.files
            // console.log(res.files)
            // this.categories = res.categories;
          });
  }



  selectFolder(folder: any) {
    this.selectedFolder = folder;
  }

  getSelectedFolderFiles() {
    return this.files.filter(file => file.folderId === this.selectedFolder?.id);
  }

  createNewFolder() {

  }

  editFolder() {
    return null;
  }

  removeFolder() {

  }
}
